var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconBars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80322 2.72815C8.80322 2.46931 8.59346 2.2594 8.33447 2.2594H3.6001C3.34111 2.2594 3.13135 2.46931 3.13135 2.72815V14.8688C3.13135 15.1278 3.34111 15.3375 3.6001 15.3375H8.33447C8.59346 15.3375 8.80322 15.1278 8.80322 14.8688V2.72815ZM4.06885 3.1969H7.86572V14.4469H4.06885V3.1969Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.397 7.46228C16.397 7.20344 16.1872 6.99353 15.9282 6.99353H11.6157C11.3567 6.99353 11.147 7.20344 11.147 7.46228V14.9154C11.147 15.1744 11.3567 15.3841 11.6157 15.3841H15.9282C16.1872 15.3841 16.397 15.1744 16.397 14.9154V7.46228ZM12.0845 7.93103H15.4595V14.4466H12.0845V7.93103Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8814 16.6029H1.06885C0.809864 16.6029 0.600098 16.8128 0.600098 17.0717C0.600098 17.3306 0.809864 17.5404 1.06885 17.5404H18.8814C19.1404 17.5404 19.3501 17.3306 19.3501 17.0717C19.3501 16.8128 19.1404 16.6029 18.8814 16.6029Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconBars);
export default __webpack_public_path__ + "static/media/dashboard-icon-bars.ae60b5cd1d8d063af7b959fb6c295f7b6ba956a10b114e564308685c578453db.svg";
export { ForwardRef as ReactComponent };